import {Injectable} from '@angular/core';
import {BehaviorSubject, Observable} from 'rxjs';
import {switchMap, tap} from 'rxjs/operators';
import { MyfileApiService } from 'src/app/core/services/myfile-api.service';
import { GlobalComponent } from 'src/app/global-component';
import { SearchResultModel } from 'src/app/core/models/query/search-result-model';
import { UserSearchModel } from '../../models/members/user/user-search.model';
import { UserBaseModel } from '../../models/members/user/user-base.model';
import { BaseListService } from './base-list.service';
import { UserModel } from '../../models/members/user/user.model';

@Injectable({
  providedIn: 'root'
})

@Injectable({providedIn: 'root'})

export class UserListService extends BaseListService{

  defaultUserListState: UserSearchModel = {
    sortColumnDirective: '',
    sortDirectionDirective: '',
    lastName: undefined,
    name: undefined,
    pageSize: GlobalComponent.defaultPagingInfo.pageSize,
    pageIndex: 0,
    startIndex: 0,
    email:undefined,
    sortColumn: '',
    sortDirection: '',
    searchTerm: undefined,
    userName: undefined,
    userId:undefined,
    status: undefined,
    isEnabled: undefined,
    tenantId:undefined
  };

  private _resultItems$ = new BehaviorSubject<UserModel[]>([]);

  protected override _state: UserSearchModel = { ...this.defaultUserListState };

  constructor(
    private myFileApiService: MyfileApiService) {
    super();
    this._search$.pipe(
      tap(() => this._loading$.next(true)),
      switchMap(() => this._search()),
      tap(() => this._loading$.next(false))
    ).subscribe((result: any) => {
      this._resultItems$.next(result.items);
      this._total$.next(result.count);
    });
  }

  get resultItems$() { return this._resultItems$.asObservable(); }
  set isEnabled(isEnabled: any) { this._set({isEnabled}); } 
  set status(status: any) { this._set({status}); } 
  set tenantId(tenantId: string|undefined) { this._set({tenantId}); } 

  protected _search() : Observable<SearchResultModel<UserBaseModel>|undefined> {   

    this.validateStartIndex();

    this._state.sortColumn = this.titleCaseWord(this._state.sortColumnDirective) as string;

    return this.myFileApiService.getUsers(this._state);
  }

   protected getUser(userId: string) : Observable<UserBaseModel|undefined> {   
    return this.myFileApiService.getUser(userId, this._state.tenantId);
  }

  override clearListService(): void {
    this._state = { ...this.defaultUserListState };
    this._resultItems$.next(new Array<UserModel>());
    this._total$.next(0);
  }

}